import { executeGetRequest, executePostRequest, FetchConfig } from '@api/client';
import { createFetchSearchFieldsPath, createSearchDocumentPath } from '@routing/apiUrls';
import { SearchDocumentQuery, SearchDocumentResponse } from '@models/searchDocument/SearchDocument';
import { FetchSearchFieldsResponse } from '@models/searchFields/FetchSearchFields';

export const searchDocument = async (docClass: string, data: SearchDocumentQuery, config?: FetchConfig) => {
    const result = await executePostRequest<SearchDocumentResponse>(createSearchDocumentPath(docClass), data, config);
    return result.data;
};

export const fetchSearchFields = async (docClass: string, config?: FetchConfig) => {
    const result = await executeGetRequest<FetchSearchFieldsResponse>(createFetchSearchFieldsPath(docClass), config);
    return result.data;
};
